var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "section" },
    [
      _c("b-loading", {
        attrs: { active: _vm.isLoading, "is-full-page": "" },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("div", { staticClass: "container is-fluid" }, [
        _c("div", { staticClass: "columns" }, [
          _c(
            "ul",
            _vm._l(_vm.categories, function (category) {
              return _c("li", { key: category.id }, [
                _c("h1", { staticClass: "subtitle" }, [
                  _vm._v(" " + _vm._s(category.name) + " "),
                ]),
                _c("div", { staticClass: "box" }, [
                  !_vm.$lodash.isEmpty(_vm.getFilesForCategory(category.id))
                    ? _c(
                        "div",
                        { staticClass: "field is-grouped" },
                        _vm._l(
                          _vm.getFilesForCategory(category.id),
                          function (file) {
                            return _c(
                              "div",
                              { key: file.id, staticClass: "control" },
                              [
                                _c(
                                  "b-tooltip",
                                  {
                                    attrs: {
                                      label:
                                        new Date(
                                          file.uploadDate
                                        ).toLocaleDateString("fr-FR") +
                                        ", " +
                                        file.description +
                                        ", " +
                                        file.displayName,
                                      multilined: "",
                                      type: "is-dark",
                                      size: "is-large",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "file is-small is-boxed is-centered is-primary has-name",
                                      },
                                      [
                                        _c(
                                          "label",
                                          { staticClass: "file-label" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "file-cta",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.downloadFile(
                                                      file.id,
                                                      file.displayName
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "file-icon" },
                                                  [
                                                    _c("i", {
                                                      staticClass: "fa",
                                                      class: _vm._f("coolFont")(
                                                        file.displayName
                                                      ),
                                                    }),
                                                  ]
                                                ),
                                                _c(
                                                  "span",
                                                  { staticClass: "file-label" },
                                                  [_vm._v(" Download ")]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "file-name" },
                                              [
                                                [
                                                  _vm._v(
                                                    _vm._s(file.displayName)
                                                  ),
                                                ],
                                              ],
                                              2
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          }
                        ),
                        0
                      )
                    : _c("div", [_c("p", [_vm._v("There is no file here")])]),
                ]),
                _c("hr"),
              ])
            }),
            0
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }